import { SVGProps, Ref, forwardRef } from 'react';

export const LightbulbOnOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6a6 6 0 0 1 5.46 8.49c-1.15 2.514-1.723 3.772-1.792 4.087s-.068.617-.068 1.22v.603c0 2.7-1.8 3.6-3.6 3.6s-3.6-.9-3.6-3.6v-.603c0-.603 0-.905-.068-1.22-.051-.236-.387-1.003-1.037-2.433L6.54 14.49A6 6 0 0 1 12 6m-1.8 14.4c0 .917.285 1.27.478 1.43.25.209.69.37 1.322.37s1.072-.161 1.322-.37c.169-.14.408-.428.465-1.111l.013-.319v-.5h-3.6zM12 7.8a4.2 4.2 0 0 0-3.823 5.941 310 310 0 0 1 1.31 2.889q.226.51.367.854c.056.14.13.328.187.52l.025.096h3.868a5 5 0 0 1 .213-.616q.14-.344.367-.854c.3-.68.737-1.636 1.31-2.889A4.2 4.2 0 0 0 12 7.8"
                    fill="currentColor"
                />
                <path d="M4.253 11.1a8 8 0 0 0 0 1.8H0v-1.8z" fill="currentColor" />
                <path d="M24 12.9h-4.253a8 8 0 0 0 0-1.8H24z" fill="currentColor" />
                <path d="M7.16 5.886c-.473.374-.9.801-1.274 1.273L2.878 4.151 4.15 2.878z" fill="currentColor" />
                <path d="M21.122 4.151 18.113 7.16a7.8 7.8 0 0 0-1.273-1.273l3.009-3.008z" fill="currentColor" />
                <path d="M12.9 4.253a8 8 0 0 0-1.8 0V0h1.8z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
LightbulbOnOutlinedSize24Glyph.displayName = 'LightbulbOnOutlinedSize24Glyph';
